import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-container">
        
        {/* --- TOP SECTION (Main Navigation) --- */}
        <div className="footer-grid">
            
            {/* 1. BRAND COLUMN (Fixed Alignment) */}
            <div className="footer-brand">
                {/* Logo & Name Wrapper */}
                <Link to="/" className="brand-wrapper">
                    <img src="/logo_fullmockup.png" alt="FullMockup" className="brand-logo-footer" />
                    <span className="brand-name-footer">FullMockup</span>
                </Link>
                
                {/* Social Links (Strictly below logo) */}
                <div className="social-links">
                    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <i className="bi bi-instagram"></i>
                    </a>
                    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <i className="bi bi-twitter"></i>
                    </a>
                    <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon">
                        <i className="bi bi-linkedin"></i>
                    </a>
                </div>
            </div>

            {/* 2. MOCKUP CREATOR */}
            <div className="footer-col">
                <h3>Mockup Creator</h3>
                <div className="footer-links">
                    <Link to="/apparel" className="footer-link">Apparel</Link>
                    <Link to="/home-living" className="footer-link">Home & Living</Link>
                    <Link to="/tech-social" className="footer-link">Tech & Social</Link>
                </div>
            </div>

            {/* 3. IMAGE TOOLS */}
            <div className="footer-col">
                <h3>Image Tools</h3>
                <div className="footer-links">
                    {/* NEW LINK ADDED HERE */}
                    <Link to="/tool" className="footer-link">All AI Tools</Link>
                    
                    <Link to="/app/tool/background-remove" className="footer-link">Remove Background</Link>
                    <Link to="/app/tool/background-replacer" className="footer-link">Replace Background</Link>
                    <Link to="/app/tool/blur-background" className="footer-link">Blur Background</Link>
                    <Link to="/app/tool/image-converter" className="footer-link">Convert Image</Link>
                </div>
            </div>

            {/* 4. COMPANY */}
            <div className="footer-col">
                <h3>Company</h3>
                <div className="footer-links">
                    <Link to="/about-us" className="footer-link">About Us</Link>
                    <Link to="/contact-us" className="footer-link">Contact Us</Link>
                    <Link to="/faq" className="footer-link">FAQ</Link>
                    <Link to="/blog" className="footer-link">Blog</Link>
                    <Link to="/pricing" className="footer-link">Pricing</Link>
                </div>
            </div>

        </div>

        {/* --- BOTTOM SECTION (Copyright & Legal) --- */}
        <div className="footer-bottom">
            
            {/* LEFT: Copyright */}
            <div className="copyright">
                <p>© {currentYear} FullMockup. All rights reserved.</p>
            </div>

            {/* RIGHT: Legal Links (Grid on Mobile) */}
            <div className="legal-links">
                <Link to="/terms" className="legal-link">Terms & Condition</Link>
                <Link to="/privacy" className="legal-link">Privacy Policy</Link>
                <Link to="/refund" className="legal-link">Refund & Cancelation</Link>
                <Link to="/sitemap" className="legal-link">Sitemap</Link>
            </div>

        </div>
    </footer>
  );
};

export default Footer;